import React, { useState } from "react";
import BaseDialog, { Field, FieldSet } from "../../modelDialogs/BaseDialog";

import KnxProductData from "../../KnxProductdata";

import { showErrToast, showToast } from "../Toasts";
import Logger from "../../Logger";
import axios from "../../utils/axios";
import { itx } from "../../translationItx/itx";

const logger = new Logger();

export default function ProblemWithProductDialog(props: { productData: KnxProductData | undefined }) {
  const { productData } = props;
  const [contactAllowed, setContactAllowed] = useState(true);
  const [subject, setSubject] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("nothing selected"); // no itx
  const serviceOption = new Array<any>();

  const serviceMap = new Map<string, string>();
  serviceMap.set(
    "nothing selected", // no itx
    state.translate("ProblemWithProductDialog.selectCategory", "please select an issue"),
  );
  serviceMap.set(
    "channel sorting", // no itx
    state.translate("ProblemWithProductDialog.sortingChannel", "sorting and creation of Channels"),
  );
  serviceMap.set(
    "connecting with Consumer", // no itx
    state.translate("ProblemWithProductDialog.connectingWithConsumer", "connecting with Consumer"),
  );
  serviceMap.set(
    "probem with scenes", // no itx
    state.translate("ProblemWithProductDialog.scenesProblem", "problem with scenes"),
  );

  serviceMap.forEach((value, key) => {
    serviceOption.push(<option value={key}>{value}</option>);
  });

  function sendObjToBackend() {
    const productInfo = productData?.productInfo;
    let productName = productInfo?.ProductName || productInfo?.DefaultProductName;
    let orderNumber = productInfo?.OrderNumber;
    let manufacturer = productInfo?.ManufacturerName;
    if (productData == undefined) {
      const productNameElement = document.getElementById("input-productName") as HTMLInputElement;
      productName = productNameElement.value;

      const orderNumberElement = document.getElementById("input-orderNumber") as HTMLInputElement;
      orderNumber = orderNumberElement.value;
      const manufacturerElement = document.getElementById("input-manufacturer") as HTMLInputElement;
      manufacturer = manufacturerElement.value;
    }

    const message: any = document.getElementById("textareaInputProblem");
    const problemText = message?.value;

    axios
      .post("/api/support/knxproduct", {
        // .post("/api/project/invite/user", {
        projectName: state.projectMetadata.name,
        productName:
          productName || itx("ProblemWithProductDialog.produktnamenichtangegeben", "Produktname nicht angegeben"),
        orderNumber:
          orderNumber || itx("ProblemWithProductDialog.bestellnummernichtangegeben", "Bestellnummer nicht angegeben"),
        manufacturer:
          manufacturer || itx("ProblemWithProductDialog.herstellernichtangegeben", "Hersteller nicht angegeben"),
        selectedProblem: productInfo
          ? selectedCategory
          : itx("ProblemWithProductDialog.fehlendesknxprodukt", "fehlendes KNX Produkt"),
        subject:
          subject ||
          itx("ProblemWithProductDialog.supportRequestWithoutSubject", "Supportanfrage: T1", { T1: selectedCategory }),
        text: problemText,
        contactAllowed: contactAllowed,
      })
      .then((result: any) => {
        showToast({
          text: state.translate(
            "ProblemWithProductDialog.reviewSent",
            "Ihre Meldung wurde an den ESTADA support gesendet",
          ),
        });
      })
      .catch((e) => {
        logger.error(e);
        let failureMesssage: string = "";
        if (typeof e.DATA == `string`) {
          failureMesssage = e.DATA;
        } else {
          failureMesssage = e.MESSAGE;
        }
        showErrToast(failureMesssage);
      });
  }

  return (
    <BaseDialog
      title={
        productData
          ? state.translate(
              "ProblemWithProductDialog.reportProblemWithProduct",
              "Wollen Sie ein Problem mit dem Produkt melden?",
            )
          : itx("ProblemWithProductDialog.productInquiry", "Produktanfrage")
      }
      okCaption={
        productData
          ? state.translate("ProblemWithProductDialog.report", "melden")
          : itx("ProblemWithProductDialog.inquiry", "absenden")
      }
      onClose={() => {
        return true;
      }}
      onOk={() => {
        const message: any = document.getElementById("textareaInputProblem");
        const problemText = message?.value;
        let productName = "";
        let orderNumber = "";
        let manufacturer = "";
        if (productData == undefined) {
          const productNameElement = document.getElementById("input-productName") as HTMLInputElement;
          productName = productNameElement.value;

          const orderNumberElement = document.getElementById("input-orderNumber") as HTMLInputElement;
          orderNumber = orderNumberElement.value;
          const manufacturerElement = document.getElementById("input-manufacturer") as HTMLInputElement;
          manufacturer = manufacturerElement.value;
        }
        if (
          productData &&
          (selectedCategory != "nothing selected" || subject != "" || contactAllowed || problemText != "")
        ) {
          sendObjToBackend();
          return true;
        } else if (!productData) {
          if ((productName != "" || orderNumber != "") && manufacturer != "") {
            sendObjToBackend();
            return true;
          }
          showToast({
            text: itx("ProblemWithProductDialog.pleaseEnterProductData", "Bitte geben Sie die Produktdaten an"),
          });
          return false;
        }
        showToast({
          text: itx("ProblemWithProductDialog.explainProblem", "Bitte erläutern Sie Ihr Problem möglichst genau"),
        });
        return false;
      }}
      enterAsOk={false}
    >
      {!productData && (
        <div
          style={{
            background: "var(--panel-background)",
            borderRadius: "var(--panel-border-radius)",
            boxShadow: "var(--panel-shadow)",
            padding: "4px 10px 1px 10px",
            marginBottom: "8px",
          }}
        >
          <FieldSet>
            <Field label={state.translate("ProblemWithProductDialog.productName", "Produktname") + ":"}>
              <input id="input-productName" />
            </Field>
            <Field label={state.translate("ProblemWithProductDialog.orderNumber", "Bestellnummer") + ":"}>
              <input id="input-orderNumber" />
            </Field>
            <Field label={state.translate("ProblemWithProductDialog.manufacturer", "Hersteller") + ":"}>
              <input id="input-manufacturer" />
            </Field>
          </FieldSet>
        </div>
      )}

      {productData && (
        <>
          <div
            style={{
              background: "var(--panel-background)",
              borderRadius: "var(--panel-border-radius)",
              boxShadow: "var(--panel-shadow)",
              padding: "4px 10px 4px 10px",
              marginBottom: "8px",
            }}
          >
            <table style={{ borderSpacing: "10px 6px", borderCollapse: "inherit" }}>
              <tbody>
                <tr>
                  <td style={{ color: "var(--label-color)", whiteSpace: "nowrap" }}>
                    {state.translate("ProblemWithProductDialog.productName", "Produktname")}:
                  </td>
                  <td>{productData.productInfo?.ProductName || productData.productInfo?.DefaultProductName}</td>
                </tr>
                <tr>
                  <td style={{ color: "var(--label-color)", whiteSpace: "nowrap" }}>
                    {state.translate("ProblemWithProductDialog.orderNumber", "Bestellnummer")}:
                  </td>
                  <td>{productData.productInfo?.OrderNumber}</td>
                </tr>
                <tr>
                  <td style={{ color: "var(--label-color)", whiteSpace: "nowrap" }}>
                    {state.translate("ProblemWithProductDialog.manufacturer", "Hersteller")}:
                  </td>
                  <td>{productData.productInfo?.ManufacturerName}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <FieldSet>
            <Field label={state.translate("ProblemWithProductDialog.supportCategory", "Support-Category") + ":"}>
              <select
                id="select-Category"
                onChange={(ev) => {
                  setSelectedCategory(ev.target.value);
                }}
              >
                {serviceOption}
              </select>
            </Field>
            <Field label={state.translate("ProblemWithProductDialog.subject", "Betreff") + ":"}>
              <input
                maxLength={state.maxCharLimit.text}
                onChange={(ev) => {
                  setSubject(ev.target.value);
                }}
                defaultValue=""
              />
            </Field>
          </FieldSet>
        </>
      )}

      <div className="form-label" style={{ marginTop: "14px", marginBottom: "6px" }}>
        {productData
          ? state.translate("ProblemWithProductDialog.problemDescription", "beschreibe das Problem")
          : itx("ProblemWithProductDialog.describeInquiry", "zuzügliche Infos")}
      </div>

      <textarea
        id="textareaInputProblem"
        style={{
          height: "160px",
          width: "100%",
          boxSizing: "border-box",
          resize: "vertical",
          padding: "8px",
          borderRadius: "4px",
          border: "1px solid var(--fieldBorderColor)",
          fontFamily: "inherit",
          fontSize: "var(--font-standard)",
        }}
        onBlur={(ev) => {}}
      />

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          marginTop: "12px",
          padding: "8px 12px",
          background: "var(--panel-background)",
          borderRadius: "var(--panel-border-radius)",
        }}
      >
        <input
          key={"checkBotcontactAllowed"} // no itx
          type="checkbox"
          onChange={(ev) => {
            setContactAllowed(!contactAllowed);
          }}
          defaultChecked={contactAllowed}
        />
        <span style={{ fontSize: "var(--font-standard)" }}>
          {state.translate("ProblemWithProductDialog.problemGetEmailBack", "problemGetEmailBack")}
        </span>
      </div>
    </BaseDialog>
  );
}
